import { render, staticRenderFns } from "./ProductSimpleCard.vue?vue&type=template&id=117fb03d&scoped=true&"
import script from "./ProductSimpleCard.vue?vue&type=script&lang=ts&"
export * from "./ProductSimpleCard.vue?vue&type=script&lang=ts&"
import style0 from "./ProductSimpleCard.vue?vue&type=style&index=0&id=117fb03d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117fb03d",
  null
  
)

export default component.exports